// eslint-disable-next-line import/prefer-default-export
export const SORT_VALUE = 'bundled_shipment';
